module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page greyBg"
  }, [_c('pageTitle', {
    attrs: {
      "title": "提示",
      "RightImgName": "home"
    }
  }), _vm._v(" "), (!_vm.IsLoading && _vm.seconds <= 1800 && _vm.seconds > 0 && _vm.OrderDetails.IsSpecialRoom) ? _c('div', {
    staticClass: "countdown whiteBg"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/payOrder/hourglass.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("倒计时 " + _vm._s(_vm.downMinutes) + ":" + _vm._s(_vm.downSeconds))]), _vm._v(" "), _c('div', [_vm._v("请在30分钟内完成支付，超时未支付将自动取消。")])])]) : (!_vm.IsLoading && _vm.seconds <= 0 && _vm.OrderDetails.IsSpecialRoom) ? _c('div', {
    staticClass: "countdown whiteBg"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/hotel/打叉.png")
    }
  }), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "countdown whiteBg"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/hotel/打钩.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("预订成功，待支付")]), _vm._v(" "), _c('div', [_vm._v("如未完成预付，您的订单将保留至" + _vm._s(_vm.holdTime))])])]), _vm._v(" "), _c('div', {
    staticClass: "orderMsg whiteBg"
  }, [_vm._v("\n    订单号：\n    "), _c('span', [_vm._v(_vm._s(_vm.g_PayOrder.OrderId))]), _vm._v(" "), _c('div', [_vm._v("\n      总   价：\n      "), _c('span', [_vm._v("￥ " + _vm._s(_vm._f("fomatFloat")(_vm.g_PayOrder.Money)))])]), _vm._v(" "), (_vm.OrderDetails.SpecialCode == 'C0000001' || _vm.OrderDetails.SpecialCode == 'C0000075' || _vm.OrderDetails.SpecialCode == 'C0000187') ? _c('div', [_vm._v("\n      备   注：\n      "), _c('span', [_vm._v("入住日前一天18：00前可免费取消，逾期或未入住需收取全额房费作为违约金。")])]) : _vm._e()]), _vm._v(" "), (_vm.IsLoading) ? _c('div', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IsLoading),
      expression: "  IsLoading  "
    }],
    staticStyle: {
      "width": "1.2rem",
      "margin": "2.1rem auto 0 auto"
    },
    attrs: {
      "src": require("../../../static/LoadingBest.gif")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.IsLoading) ? _c('div', {
    staticClass: "main whiteBg"
  }, [_c('div', {
    staticClass: "wallet"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("我的钱包")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', [_vm._v("K币")]), _vm._v(" "), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.g_walletInfo.KCoin))]), _vm._v(" "), _c('span', [_vm._v("储值卡")]), _vm._v(" "), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.g_walletInfo.StoreCardMoney) + "元")])])]), _vm._v(" "), _c('div', {
    staticClass: "payType"
  }, [_c('div', {
    staticClass: "title",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("支付方式")]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.normalPage) ? _c('mu-list', {
    staticStyle: {
      "font-size": "0.3rem"
    }
  }, [_c('mu-divider'), _vm._v(" "), (_vm.loginState) ? _c('mu-list-item', {
    on: {
      "click": function($event) {
        return _vm.goPay(1)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/SmallStore.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("\n            储值卡支付\n            "), _c('nobr', {
    staticClass: "Orange",
    staticStyle: {}
  }, [_vm._v("充1000送1000K币")])], 1), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right",
      "color": "#efefef"
    },
    slot: "right"
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-divider'), _vm._v(" "), (_vm.loginState) ? _c('mu-list-item', {
    on: {
      "click": function($event) {
        return _vm.goPay(2)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/SmallUnionPay.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("银联支付")]), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right",
      "color": "#efefef"
    },
    slot: "right"
  })], 1) : _c('mu-list-item', {
    on: {
      "click": function($event) {
        return _vm.goPay(5)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/SmallUnionPay.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("银联支付")]), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right",
      "color": "#efefef"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list-item', {
    style: ({
      display: _vm.allowAlipay
    }),
    on: {
      "click": function($event) {
        return _vm.goPay(3)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/SmallAlipay.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right",
      "color": "#efefef"
    },
    slot: "right"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("支付宝支付")])], 1), _vm._v(" "), _c('mu-divider', {
    style: ({
      display: _vm.allowAlipay
    })
  }), _vm._v(" "), _c('mu-list-item', {
    style: ({
      display: _vm.allowWepay
    }),
    on: {
      "click": function($event) {
        return _vm.goPay(6)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/wepay.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "color": "#efefef",
      "value": "keyboard_arrow_right"
    },
    slot: "right"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("微信支付")])], 1), _vm._v(" "), _c('mu-divider', {
    style: ({
      display: _vm.allowWepay
    })
  }), _vm._v(" "), _c('mu-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.jdPage) ? _c('mu-list', {
    staticStyle: {
      "font-size": "0.3rem"
    }
  }, [_c('mu-divider'), _vm._v(" "), (_vm.loginState) ? _c('mu-list-item', {
    on: {
      "click": function($event) {
        return _vm.goPay(1)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/SmallStore.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("\n            储值卡支付  \n           ")]), _vm._v(" "), _c('div', [_c('nobr', {
    staticClass: "Orange",
    staticStyle: {
      "font-size": "0.25rem",
      "color": "#ff6a6a"
    }
  }, [_vm._v("充1000送1000K币")])], 1), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right",
      "color": "#efefef"
    },
    slot: "right"
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-divider'), _vm._v(" "), (_vm.loginState) ? _c('mu-list-item', {
    on: {
      "click": function($event) {
        return _vm.goPay(2)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/SmallUnionPay.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("银联支付")]), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right",
      "color": "#efefef"
    },
    slot: "right"
  })], 1) : _c('mu-list-item', {
    on: {
      "click": function($event) {
        return _vm.goPay(5)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/SmallUnionPay.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("银联支付")]), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right",
      "color": "#efefef"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list-item', {
    on: {
      "click": function($event) {
        return _vm.goPay(6)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/wepay.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "color": "#efefef",
      "value": "keyboard_arrow_right"
    },
    slot: "right"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("微信支付")])], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list-item', {
    on: {
      "click": function($event) {
        return _vm.goPay(7)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/Smalljd.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "color": "#efefef",
      "value": "keyboard_arrow_right"
    },
    slot: "right"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("京东支付")]), _vm._v(" "), _c('div', [_c('nobr', {
    staticClass: "Orange",
    staticStyle: {
      "font-size": "0.25rem",
      "color": "#ff6a6a"
    }
  }, [_vm._v("开通白条立减30 老客随机立减")])], 1)], 1), _vm._v(" "), _c('mu-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.ysfPage) ? _c('mu-list', {
    staticStyle: {
      "font-size": "0.3rem"
    }
  }, [_c('mu-divider'), _vm._v(" "), (_vm.loginState) ? _c('mu-list-item', {
    on: {
      "click": function($event) {
        return _vm.goPay(1)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/SmallStore.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("\n            储值卡支付  \n           ")]), _vm._v(" "), _c('div', [_c('nobr', {
    staticClass: "Orange",
    staticStyle: {
      "font-size": "0.25rem",
      "color": "#ff6a6a"
    }
  }, [_vm._v("充1000送1000K币")])], 1), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right",
      "color": "#efefef"
    },
    slot: "right"
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-divider'), _vm._v(" "), (_vm.loginState) ? _c('mu-list-item', {
    on: {
      "click": function($event) {
        return _vm.goPay(8)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/YsfPay.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "color": "#efefef",
      "value": "keyboard_arrow_right"
    },
    slot: "right"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("云闪付")]), _vm._v(" "), _c('div')], 1) : _vm._e(), _vm._v(" "), _c('mu-divider')], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#666666",
      "text-align": "center"
    }
  }, [_vm._v("抱歉，您尚未开通储值卡！")]), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "去开通"
    },
    on: {
      "click": _vm.goOpenValue
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "取消"
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("订单已取消")]), _vm._v(" "), _c('div', [_vm._v("由于您未在规定的时间内完成支付，订单已取消。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title",
    staticStyle: {
      "float": "right",
      "font-size": "0.22rem",
      "color": "#999999",
      "padding-top": "0.08rem"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "0.2rem",
      "margin-bottom": "-0.02rem",
      "padding-right": "0.06rem"
    },
    attrs: {
      "src": require("../../../static/payOrder/tick.png")
    }
  }), _vm._v(" 全额可退，优先选房，迅捷入住\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f2574e48!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/payOrder/payType.vue
// module id = 1614
// module chunks = 18